import React from 'react';
import { motion } from 'framer-motion';
import { MessageSquareIcon, ClockIcon, XCircleIcon, HelpCircleIcon } from 'lucide-react';
export function TextMessagingInfo() {
  const cards = [{
    title: 'Why You May Receive Texts',
    text: 'Clients who opt in may receive appointment confirmations, reminders, service-related updates, and occasional promotional offers.',
    icon: MessageSquareIcon
  }, {
    title: 'Message Frequency',
    text: 'Message frequency may vary depending on your appointments, requests, and communication preferences.',
    icon: ClockIcon
  }, {
    title: 'How to Stop',
    text: 'Reply STOP at any time to unsubscribe from SMS communications.',
    icon: XCircleIcon
  }, {
    title: 'Need Help?',
    text: 'Reply HELP for assistance or contact our team directly through our contact information.',
    icon: HelpCircleIcon
  }];
  return <section className="py-20 bg-brand-black border-t border-brand-charcoal" data-id="element-253">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-254">
        <div className="text-center mb-12" data-id="element-255">
          <h2 className="font-heading text-3xl text-brand-white mb-4" data-id="element-256">
            How Our Text Messaging Works
          </h2>
          <div className="w-12 h-px bg-brand-gold mx-auto" data-id="element-257"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-258">
          {cards.map((card, index) => <motion.div key={card.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-brand-charcoal/30 border border-brand-charcoal p-6 rounded-sm text-center hover:border-brand-gold/30 transition-colors duration-300" data-id="element-259">
              <card.icon className="w-8 h-8 text-brand-gold mx-auto mb-4" strokeWidth={1.5} data-id="element-260" />
              <h3 className="font-heading text-lg text-brand-white mb-3" data-id="element-261">
                {card.title}
              </h3>
              <p className="text-sm text-brand-champagne-light/70 leading-relaxed" data-id="element-262">
                {card.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}